import { Redirect, Route } from 'wouter';

const Public = ({component: Component, ...rest}) => {
  const isLogged = false;

  return (
    isLogged ? <Redirect to="/dashboard" /> : <Route {...rest} component={Component} />
  )
}

export default Public;
